export default __webpack_public_path__ + "static/media/etherscan.83fe6445.svg";